import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

export default function TermsOfService() {
  return (
    <PolicyLayout title="Terms and Conditions" updated="May 13, 2026">
      <p>
        Welcome to AutoLink (the "Service"), which is owned and operated by CoreLink Technologies Inc. ("the Company").
        Please read these Terms and Conditions ("Terms") carefully before creating an account. By clicking "I Agree" or
        signing up, you agree to be bound by these Terms.
      </p>

      <div>
        <h3>1. Acceptance of Terms</h3>
        <p>
          By creating an AutoLink account, you represent that you are an authorized representative of a legally registered
          vehicle dealership and have the authority to bind that entity to these Terms.
        </p>
      </div>

      <div>
        <h3>2. Account Security &amp; User Limits</h3>
        <ul>
          <li><strong>Accuracy:</strong> You must provide accurate, current, and complete information during registration.</li>
          <li><strong>User Caps:</strong> You agree not to exceed the team member limits specified in your chosen AutoLink pricing tier. Account credentials cannot be shared between multiple dealership locations or non-employees.</li>
          <li><strong>Security:</strong> You are solely responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</li>
        </ul>
      </div>

      <div>
        <h3>3. Subscription Pricing and Stripe Billing</h3>
        <ul>
          <li><strong>Payment Processing:</strong> All payments are securely processed through our third-party payment gateway, Stripe. By signing up, you authorize Stripe to automatically charge your designated payment method on a recurring monthly or annual basis.</li>
          <li><strong>Failed Payments:</strong> If a payment fails, the Company reserves the right to suspend or terminate your access to the Service immediately until payment is resolved.</li>
          <li><strong>No Refunds:</strong> All fees are non-refundable. The Company does not provide refunds or credits for partial months of service or unused accounts.</li>
          <li><strong>Tier Overages:</strong> Exceeding your tier's vehicle inventory limits may result in temporary restriction of data entry or an automatic transition to the correct pricing tier upon email notification.</li>
        </ul>
      </div>

      <div>
        <h3>4. Data Accuracy and Dealership Responsibility</h3>
        <ul>
          <li><strong>Inventory Content:</strong> You retain ownership of all vehicle data, text, and images you upload to AutoLink.</li>
          <li><strong>Legal Compliance:</strong> You are solely responsible for ensuring that all vehicle pricing, mileage, VIN data, and descriptions comply with local automotive advertising laws. The Company is not liable for any consumer disputes arising from incorrect inventory information displayed or managed through our app.</li>
        </ul>
      </div>

      <div>
        <h3>5. System Availability and Limitation of Liability</h3>
        <ul>
          <li><strong>"As-Is" Service:</strong> AutoLink is provided on an "as-is" and "as-available" basis. We do not guarantee uninterrupted uptime.</li>
          <li><strong>Uptime Disruption:</strong> Scheduled maintenance or unexpected server downtime does not entitle you to refunds, credits, or compensation from the Company.</li>
          <li><strong>Limitation of Liability:</strong> To the maximum extent permitted by law, CoreLink Technologies Inc. shall not be liable for any indirect, incidental, special, or consequential damages, including loss of profits, dealership data, or business opportunities.</li>
        </ul>
      </div>

      <div>
        <h3>6. Intellectual Property</h3>
        <p>
          All software, code, layout designs, trademarks, and logos associated with AutoLink are the exclusive intellectual
          property of the Company. You may not copy, reverse-engineer, or duplicate any part of our software.
        </p>
      </div>

      <div>
        <h3>7. Termination of Account</h3>
        <p>
          The Company reserves the right to terminate or suspend your account at our sole discretion, without prior notice,
          for conduct that violates these Terms, infringes on intellectual property, or involves fraudulent activity.
        </p>
      </div>

      <div>
        <h3>8. Governing Law and Jurisdiction</h3>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the Province of Alberta and the
          federal laws of Canada applicable therein. Any legal action or proceeding arising under these Terms shall be
          brought exclusively in the courts located in Edmonton, Alberta, Canada.
        </p>
      </div>
    </PolicyLayout>
  );
}
